"use strict";

exports.__esModule = true;
exports.default = void 0;
var _partial = _interopRequireDefault(require("./partial.js"));
var _delay = _interopRequireDefault(require("./delay.js"));
var _underscore = _interopRequireDefault(require("./underscore.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Defers a function, scheduling it to run after the current call stack has
// cleared.
var _default = exports.default = (0, _partial.default)(_delay.default, _underscore.default, 1);